import {observable} from 'mobx';

import {SeoApp} from './seo-app';
import {SeoLocaleKey} from './seo-locale-key';
import {LocaleHint} from './locale-hint';

import {construct, createInstance, ModelProperties} from '../utils';

export class SeoLocaleKeyHints {
    @observable id!: number;

    @observable keyId!: number;

    @observable hintId!: number;

    @observable appId?: number | null;

    @observable key?: SeoLocaleKey;

    @observable hint?: LocaleHint;

    @observable app?: SeoApp;

    constructor(hints?: ModelProperties<SeoLocaleKeyHints>) {
        if (hints) {
            construct(this, hints);
            this.hint = createInstance(LocaleHint, hints.hint);
            this.app = createInstance(SeoApp, hints.app);
            this.key = createInstance(SeoLocaleKey, hints.key);
        }
    }
}